// extracted by mini-css-extract-plugin
export default {"productGallery":"JH-z","inQuickShop":"KH-z"};